<label class="form-label text-white">{{ label }}</label>
<input readonly type="text" id="{{ id }}-date" placeholder="{{ placeholder }}" class="form-control cursor-pointer" [required]="required" [value]="value | date:'dd LLL yyyy'">

<ion-modal trigger="{{ id }}-date" *transloco="let t;">
    <ng-template>
        <ion-datetime mode="md" id="date" presentation="date" value="{{ value }}" doneText="{{ t('button.submit') }}" cancelText="{{ t('button.cancel') }}" [showDefaultButtons]="true" (ionChange)="changeDate($event)" />
    </ng-template>
</ion-modal>

@if (errorMsg) {
    <label class="is-invalid">{{ errorMsg }}</label>
}
